import react, { useEffect } from 'react';
import { BrowserRouter as Router, Route, NavLink } from 'react-router-dom';
import "../GoXDashboard/GoXDashboard.css"
import Dashboard from '../../components/Dashboard';
import Attendance from '../../components/Attendance';
import LeaveManagement from '../../components/LeaveManagement';
import Payroll from '../../components/Payroll';
import Attend from '../../assets/Attend.png'
import dash from '../../assets/dash.png'
import Leave from '../../assets/Leave.png'
import admin from '../../assets/admin.png'
import setting from '../../assets/setting.png'
import docum from '../../assets/docum.png'
import Recruit from '../../assets/Recruit.png'
import pay from '../../assets/pay.png'
import logout from '../../assets/logout.png'
import profile from '../../assets/profile.png'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmployeeFolder from '../../components/EmployeeFolder/EmployeeFolder';
// Import other components as needed

function GoXDashboard({children}) {
  const navigate = useNavigate()

  const [tab, setTab] = useState('')
  
  const data = sessionStorage.getItem("userInfo");

  useEffect(() => {
if (!data) {
    navigate('/login')
  } else {
    navigate('/employee')
  }
  }, [data])

  
    

  return (
    
      <div className='d-flex'>
        <nav className=' navLeft'>
          <h1 className='mx-3 mt-5 goxReg'>GOX Register</h1>
          <ul className='navbar-nav m-3 dashborditems'>
            <li className='nav-item mb-3  employLink'>
              <NavLink to="/Dashboard " id='gox-link' onClick={() => setTab('Dashboard')} className={tab === 'Dashboard' && ''}><img src={dash} alt="" /> Dashboard</NavLink>
            </li>
            <li className='nav-item mb-3 employLink'  >
              <NavLink to="/Employee" id='gox-link' onClick={() => setTab('Employee')} className={tab === 'Employee' && ''} ><img src={profile} alt="" /> Employees </NavLink>
            </li>
            <li className='nav-item mb-3  employLink' >
              <NavLink to="/Attendance" id='gox-link' onClick={() => setTab('Attendance')} className={tab === 'Attendance' && ''} ><img src={Attend} alt="" /> Attendance </NavLink>
            </li>
            <li className='nav-item mb-3  employLink'>
              <NavLink to="/payroll" id='gox-link' onClick={() => setTab('payroll')} className={tab === 'payroll' && ''}  ><img src={pay} alt="" />Payroll</NavLink>
            </li>
            <li className='nav-item mb-3  employLink'>
              <NavLink to="/LeaveManagement" id='gox-link' ><img src={Leave} alt="" /> Leave management</NavLink>
            </li>
            <li className='nav-item mb-3  employLink'>
              <NavLink to="/Recruitment" id='gox-link' ><img src={Recruit} alt="" /> Recruitment</NavLink>
            </li>
            <li className='nav-item mb-3  employLink'>
              <NavLink to="/Document" id='gox-link' ><img src={docum} alt="" /> Documents</NavLink>
            </li>
            <li className='nav-item mb-3  employLink'>
              <NavLink to="/Administration" id='gox-link' ><img src={admin} alt="" /> Administration</NavLink>
            </li>
            <li className='nav-item mb-5  employLink'>
              <NavLink to="/Setting" id='gox-link' ><img src={setting} alt="" />Settings</NavLink>
            </li>
            <li className='nav-item mt-5 log  employLink'>
              <NavLink to="/Logout" id='gox-link' ><img src={logout} alt="" />Log out</NavLink>
            </li>
            {/* Add more navigation links */}
          </ul>
        </nav>

       <div className=''>
         {children}
       </div>
      </div>
    
  );
}

export default GoXDashboard;
